import { motion } from "framer-motion";
import { useI18n } from "@/i18n/I18nContext";

const fade = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.2, 0.7, 0.2, 1] } },
};

export default function Intro() {
  const { t } = useI18n();
  const paragraphs = [
    t("intro.paragraph_1"),
    t("intro.paragraph_2"),
    t("intro.paragraph_3"),
    t("intro.paragraph_4"),
  ];
  return (
    <section className="py-24 md:py-32" id="opportunities" data-testid="section-intro">
      <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <motion.div initial="hidden" whileInView="show" viewport={{ once: true }} variants={fade} className="eyebrow">
            {t("intro.eyebrow")}
          </motion.div>
          <motion.h2
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            variants={fade}
            className="mt-4 font-serif-display text-4xl md:text-5xl leading-[1.05] tracking-tight"
          >
            {t("intro.title")}
          </motion.h2>
        </div>
        <div className="lg:col-span-7 lg:col-start-6 prose-editorial space-y-6">
          {paragraphs.map((p, i) => (
            <motion.p
              key={i}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-60px" }}
              variants={fade}
              transition={{ delay: 0.08 * i }}
            >
              {p}
            </motion.p>
          ))}
        </div>
      </div>
    </section>
  );
}
